import React from "react"
import { Formik, Form, Field, ErrorMessage } from "formik";
import firebase from "../firebase";
import google_logo from '../login/assets/btn_google_light_normal_ios.svg';
import { useHistory } from "react-router";

const provider = new firebase.auth.GoogleAuthProvider();
const db = firebase.firestore();

export const SignUp = () => {
  const history = useHistory();
  
  return (
    <div className="profile-form">
      <h2>Create your Account</h2>
      <Formik
        initialValues={{
          email: "",
          password: "",
          confirm_password: "",   
        }}
        validate={(values) => {
          const errors: any = {};
          if (!values.email) {
            errors.email = "Required";
          }
          if (!values.email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)) {
            errors.email = "Invalid email address";
          }
          if (!values.password) {
            errors.password = "Required";
          }
          if (values.password.length < 6) {
            errors.password = "Password must be at least 6 characters";
          }
          if (values.password !== values.confirm_password) {
            errors.confirm_password = "Passwords must match"
          }

          return errors;
        }}
        onSubmit={async (values, actions) => {          
          const normalizedEmail = values.email.trim().toLowerCase();
          try {
            const user = await firebase.auth().createUserWithEmailAndPassword(normalizedEmail, values.password);
            await db.collection("profiles").doc(user.user.uid).set({
              uid: user.user.uid,
              email: user.user.email
            });
            history.push("/edit");
          } catch (e) {
            switch (e.code) {
              case "auth/email-already-in-use":
                actions.setErrors({ email: "An account with this email already exists" });
                break;
              default:
                actions.setStatus({ msg: "An unexpected error occurred" });
                console.log(e);
                break;
            }
          }
          // history.push("/");
        }}
      >
        {({ isSubmitting }) => (
          <Form className="profile-form">
            <ErrorMessage className="error" name="email" component="div" />
            <Field type="text" name="email" placeholder="Email" />
            
            <ErrorMessage className="error" name="password" component="div" />
            <Field type="password" name="password" placeholder="Password" />

            <ErrorMessage className="error" name="confirm_password" component="div" />
            <Field type="password" name="confirm_password" placeholder="Confirm Password" />

            <button className="button signup-button" type="submit" disabled={isSubmitting}>
              Create Account
            </button>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "calc(100% + 2em)", margin: "10px 0" }}>
              <div style={{ height: "1px", width: "100%", backgroundColor: "#aaaaaa" }} />
              <span style={{ margin: "0 8px 3px" }} >or</span>
              <div style={{ height: "1px", width: "100%", backgroundColor: "#aaaaaa" }} />
            </div>
            <div className="google-login-container" onClick={ () => !isSubmitting && firebase.auth().signInWithPopup(provider) }>
                <img src={google_logo} alt="google logo" />
                <span style={{ fontFamily: "Roboto" }}>Login with Google</span>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}